<template>
    <div class="productsViewerSwiper">
        <div class="swiper">

            <!-- Additional required wrapper -->
            <div class="swiper-wrapper">
                <!-- Slides -->
                <div class="swiper-slide" v-for="offer in cOffers" :key="'k-' + offer.id">
                    <public-offer class="swiper-slide-card" 
                        :offer-obj="offer" 
                        :value="value"
                        @select="$emit('input', offer.id); $emit('click')" display-select-button />
                </div>
            </div>

            <!-- If we need pagination -->
            <!-- <div class="swiper-pagination"></div> -->

            <!-- If we need navigation buttons -->
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>

            <!-- If we need scrollbar -->
            <!-- <div class="swiper-scrollbar"></div> -->

        </div>
    </div>
</template>

<script>
import publicOffer from './public-offer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default {
    name: 'productsViewerSwiper',
    components: { publicOffer },
    props: {
        value: {
            type: [Number, String],
            required: false
        },
        offers: {
            type: Array,
            required: true
        },
        swiperCfg: {
            type: Object,
            default: () => {
                return {
                    // slidesPerView: auto,
                    slidesPerView: 1,
                    spaceBetween: 10,

                    // spaceBetween: 10,
                    // centeredSlides: true,
                    loop: false,

                    breakpoints: {
                        // 640: {
                        //     slidesPerView: 2,
                        //     spaceBetween: 20,
                        // },
                        768: {
                            slidesPerView: 2,
                        },
                        1024: {
                            slidesPerView: 3,
                            // spaceBetween: 50,
                        },
                        // 1380: {
                            // slidesPerView: 4,
                            // spaceBetween: 50,
                        // },
                    },

                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    // pagination: {
                    //     el: '.swiper-pagination',
                    //     clickable: true,
                    // },
                    // scrollbar: {
                    //     el: '.swiper-scrollbar',
                    //     draggable: true,
                    // },
                }
            }
        }
    },
    computed: {
        cOffers() {
            return _.orderBy(this.offers, ['duracion', 'gbs', 'precio_nominal', 'precio'], ['asc', 'desc', 'asc', 'asc'])
        }
    },
    data: () => {
        return {
            swiperObj: null
        }
    },
    methods: {
        initSwiper() {
            if (!this.swiperObj)
                this.swiperObj = new Swiper('.swiper', this.swiperCfg);
            else
                console.log('swiperObj.created')
        },
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(this.initSwiper, 200)
        })
    }
}
</script>

<style lang="scss">

@import '@/sass/utils/variables.scss';

// @import "swiper/src";
// @import "swiper/src/components/pagination/pagination.scss";
// @import "swiper/src/components/navigation/navigation.scss";

.productsViewerSwiper {
    .swiper {
        width: 100%;

        // max-height: 680px;
        // height: 90vh;
        .swiper-slide {
            text-align: center;
            font-size: 18px;
            padding: 10px;
            padding-bottom: 30px; // Hightlight dropdown glow reserved margin.

            .row {
                margin: 0;
                padding: 0;
            }
        }
    }
}
</style>